module.exports = __webpack_public_path__ + "img/s00131.41983886.jpg";